import { useState } from "react";
import { X, Plus, RotateCcw } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export const TermListEditor = ({ label, hint, value = [], onChange, defaults, testId, tone = "rose" }) => {
  const [draft, setDraft] = useState("");
  const add = () => {
    const parts = draft.split(/[,\n]+/).map((t) => t.trim().toLowerCase()).filter(Boolean);
    if (!parts.length) return;
    onChange([...new Set([...value, ...parts])]);
    setDraft("");
  };
  const chip = tone === "rose" ? "bg-rose-500/10 border-rose-500/30 text-rose-100" : "bg-amber-400/10 border-amber-400/30 text-amber-100";
  return (
    <div data-testid={testId}>
      <div className="flex items-center justify-between gap-3">
        <div>
          <p className="text-sm font-medium leading-none">{label} <span className="text-slate-500 font-normal">({value.length})</span></p>
          {hint && <p className="mt-1 text-xs text-slate-500">{hint}</p>}
        </div>
        {defaults && <button type="button" onClick={() => onChange([...defaults])} className="inline-flex items-center gap-1 text-[11px] text-slate-400 hover:text-white shrink-0" data-testid={`${testId}-reset`}><RotateCcw size={11} /> Reset to defaults</button>}
      </div>
      <div className="mt-2 flex gap-2">
        <Input value={draft} onChange={(e) => setDraft(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); add(); } }} placeholder="Add a term — comma-separate to add several" className="bg-white/5 border-white/10" data-testid={`${testId}-input`} />
        <Button type="button" onClick={add} variant="outline" className="rounded-full border-white/15 bg-transparent hover:bg-white/10 shrink-0" data-testid={`${testId}-add`}><Plus size={14} className="mr-1" /> Add</Button>
      </div>
      <div className="mt-2 flex flex-wrap gap-1.5 max-h-40 overflow-y-auto pr-1" data-testid={`${testId}-list`}>
        {value.length === 0 && <span className="text-xs text-slate-500">Nothing blocked.</span>}
        {value.map((t) => (
          <span key={t} className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs ${chip}`} data-testid={`${testId}-term-${t.replace(/[^a-z0-9]+/g, "-")}`}>
            {t}
            <button type="button" onClick={() => onChange(value.filter((x) => x !== t))} className="opacity-70 hover:opacity-100" aria-label={`Remove ${t}`} data-testid={`${testId}-remove-${t.replace(/[^a-z0-9]+/g, "-")}`}><X size={11} /></button>
          </span>
        ))}
      </div>
    </div>
  );
};
